import { ThunkType } from "../../../../core/store/reducers";
import { setOrders, invalidateOrders } from "../ordersReportDataSlice";
import { setOrdersIndex } from "../ordersReportUXSlice";
import { PageIndex } from "../../../models";
import { getOrdersThunk } from "../../../trading/orders/thunks/getOrdersThunk";

export const loadOrdersReport = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	const { pageNumber, itemsPerPage } = store.ux.reports.ordersReport.index;
	const { filter } = store.ux.reports.ordersReport;

	const pagedOrders = await dispatch(getOrdersThunk(pageNumber, itemsPerPage, filter));

	if (pagedOrders) {
		dispatch(setOrders(pagedOrders));
	}
};

export const setOrdersIndexThunk = (index: PageIndex): ThunkType => dispatch => {
	dispatch(setOrdersIndex(index));
	dispatch(invalidateOrders());
};
